import { IDonor, IqueryParams } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

interface ExportParams extends IqueryParams<{
  donor_name?: string;
}> {
  file_format: 'pdf' | 'csv';
}

const createDonor = async (name: string) => {
  return apiService.apiRequest<IDonor>("post", `donors`, { name });
};

const getDonors = async (queryParams?: IqueryParams<{
  donor_name?: string;
}>) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<IDonor[]>("get", `/donors${query}`);
};

const getDonor = async (donor_id: string) => {
  return apiService.apiRequest<IDonor>("get", `donors/${donor_id}`);
};

const updateDonor = async (donor_id: string, data: { name: string }) => {
  return apiService.apiRequest<IDonor>("put", `donors/${donor_id}`, data);
};

const deleteDonor = async (donor_id: string) => {
  return apiService.apiRequest<any>("delete", `donors/${donor_id}`);
};

const restoreDonor = async (donor_id: string) => {
  return apiService.apiRequest<IDonor>("patch", `donors/${donor_id}/restore`);
};

const exportDonors = async (params: ExportParams) => {
  const { page, page_size, ...exportParams } = params;
  const query = buildQueryString(exportParams);

  return apiService.apiRequest<{ download_url: string }>(
    "get",
    `donors/export${query}`
  );
};

export const donorApi = {
  createDonor: createDonor,
  getDonors: getDonors,
  getDonor: getDonor,
  updateDonor: updateDonor,
  deleteDonor: deleteDonor,
  restoreDonor: restoreDonor,
  exportDonors,
};